import React from 'react';
import { CheckCircle2 } from 'lucide-react';
const modules = [{
  title: 'FONDAMENTI DELLA GINNASTICA™',
  description: 'Sviluppa solide basi grazie a esercizi fondamentali, mobilità, forza, coordinazione e preparazione fisica già organizzati per ogni livello.'
}, {
  title: 'LIBRERIA DI ESERCIZI E PROGRESSIONI™',
  description: 'Una raccolta completa di esercizi e progressioni tecniche per corpo libero, trave, parallele e volteggio, organizzata per livelli e pronta da utilizzare.'
}, {
  title: 'SISTEMA DI PIANIFICAZIONE DEGLI ALLENAMENTI™',
  description: 'Modelli di allenamento, strutture di lezione, riscaldamenti e circuiti già pronti per organizzare ogni sessione in pochi minuti.'
}, {
  title: "ALLENAMENTI PRONTI ALL'USO™",
  description: 'Decine di allenamenti completi per principianti, livello intermedio e avanzato, già preparati e pronti da mettere in pratica.'
}, {
  title: 'PROGRAMMI DI ALLENAMENTO PROGRESSIVI™',
  description: "Programmazioni stagionali e percorsi di sviluppo organizzati per accompagnare la crescita tecnica degli atleti durante tutto l'anno."
}, {
  title: "STRUMENTI PROFESSIONALI PER L'ALLENATORE™",
  description: 'Checklist, schede di valutazione, planner, strumenti organizzativi e modelli pronti per semplificare il lavoro quotidiano.'
}];
export function SolutionSection() {
  return <section className="py-8 px-4 sm:px-6 bg-white border-y-4 border-brand-ivory" data-id="element-154">
      <div className="text-center mb-6" data-id="element-155">
        <h2 className="text-2xl sm:text-3xl font-heading font-extrabold text-brand-navy mb-2 uppercase leading-tight" data-id="element-156">
          La Soluzione che Stavi Cercando
        </h2>
        <p className="text-base font-heading font-bold text-brand-violet mb-3 uppercase tracking-wide" data-id="element-157">
          Un Sistema Completo 6-in-1 per Allenatori di Ginnastica Artistica
        </p>
        <div className="inline-block bg-brand-navy text-white px-4 py-1.5 rounded-md mb-4 shadow-sm" data-id="element-158">
          <p className="font-heading font-bold text-sm tracking-wide" data-id="element-159">
            🤸 GINNASTICA PRO™
          </p>
        </div>
        <div className="text-sm sm:text-base text-brand-text font-medium leading-relaxed max-w-xl mx-auto space-y-1" data-id="element-160">
          <p data-id="element-161">Più di un semplice manuale.</p>
          <p data-id="element-162">Più di una raccolta di esercizi.</p>
          <p data-id="element-163">
            GINNASTICA PRO™ è un sistema professionale progettato per aiutare
            gli allenatori a preparare allenamenti in pochi minuti, insegnare
            con maggiore sicurezza e accompagnare ogni atleta nel proprio
            percorso di crescita.
          </p>
        </div>
      </div>

      <div className="flex flex-col gap-3" data-id="element-164">
        {modules.map((module, i) => <div key={i} className="bg-brand-ivory border border-brand-border p-4 rounded-lg flex gap-3 items-start shadow-sm hover:shadow-md transition-shadow" data-id="element-165">
            <div className="text-brand-gold shrink-0 mt-0.5" data-id="element-166">
              <CheckCircle2 className="w-6 h-6" data-id="element-167" />
            </div>
            <div data-id="element-168">
              <h3 className="text-base font-heading font-bold text-brand-navy leading-tight mb-1" data-id="element-169">
                {module.title}
              </h3>
              <p className="text-brand-text text-sm font-medium leading-relaxed" data-id="element-170">
                {module.description}
              </p>
            </div>
          </div>)}
      </div>
    </section>;
}